"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const standardSQLCompletionItemProvider_1 = require("./standardSQLCompletionItemProvider");
const standardSQLLanguageDefinition = {
    id: 'standardSql',
    extensions: ['.sql'],
    aliases: ['sql'],
    mimetypes: [],
    loader: () => require('./language'),
    completionProvider: standardSQLCompletionItemProvider_1.getStandardSQLCompletionProvider,
};
exports.default = standardSQLLanguageDefinition;
//# sourceMappingURL=definition.js.map